/* @flow */
/* eslint-disable babel/no-invalid-this */
import Dispatch from "nexia_mobile/flux_like/dispatch";
import type { SwitchFeature } from "./types";

const executeWithCheck = (device, action, errorVerb) => {
  if (action == null) {
    return Promise.reject(
      new Error(
        `Attempted to ${errorVerb} a device whose switch feature had no ${errorVerb} action`
      )
    );
  } else {
    return device.executeDeviceAction(action, {});
  }
};

export default function Switch(feature: SwitchFeature) {
  const toggleAction = feature.actions.toggle;
  const onAction = feature.actions.on;
  const offAction = feature.actions.off;

  this.canSetOnAndOffSeparately = () => Boolean(onAction && offAction);

  this.turnOn = () => {
    return executeWithCheck(this, onAction, "turn on").then(() => {
      Dispatch("DEMO_MODE_EVENT", this, "Turned on");
    });
  };

  this.turnOff = () => {
    return executeWithCheck(this, offAction, "turn off").then(() => {
      Dispatch("DEMO_MODE_EVENT", this, "Turned off");
    });
  };

  this.isOn = () => {
    return this.get("status") === "on";
  };

  this.toggle = () => {
    const demoEventDescription = this.isOn() ? "Turned off" : "Turned on";
    return executeWithCheck(this, toggleAction, "toggle").then(() => {
      Dispatch("DEMO_MODE_EVENT", this, demoEventDescription);
    });
  };

  return { status: feature.status };
}



// WEBPACK FOOTER //
// ./src/models/mixins/device_features/switch.js